Object.defineProperty(exports,"__esModule",{value:true});exports.registerComponent=exports.presentRegistered=exports.present=exports.registeredComponents=undefined;

var _bluebird=require('bluebird');var _bluebird2=_interopRequireDefault(_bluebird);

var _emitter=require('./emitter');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var registeredComponents=exports.registeredComponents={};

var counter=0;

var createComponentPromise=function createComponentPromise(
id,
component,
props)


{var resolvers=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'resolve';var rejecters=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'reject';
var resolversArray=typeof resolvers==='string'?[resolvers]:resolvers,
rejectersArray=typeof rejecters==='string'?[rejecters]:rejecters;

var promise=new _bluebird2.default(function(resolve,reject,onCancel){
_emitter.emitter.emit('presentView',id,component,props,resolve,reject,onCancel,resolversArray,rejectersArray);
});

promise.__proto__.updateProps=function(newProps){
_emitter.emitter.emit('updateProps',id,newProps);
};
return promise;
};

var getIdAndIncrementCounter=function getIdAndIncrementCounter(){
var id=counter;
counter+=1;
return id;
};

var present=exports.present=function present(
component)



{var props=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var resolvers=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'resolve';var rejecters=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'reject';
if(typeof component==='string'){
return _bluebird2.default.reject(new Error('Got string, expected component. Use registerComponent to present a registered component.'));
}

var id=getIdAndIncrementCounter();

return createComponentPromise(id,component,props,resolvers,rejecters);
};

var presentRegistered=exports.presentRegistered=function presentRegistered(componentId){var props=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};
if(!registeredComponents[componentId]){
return _bluebird2.default.reject(new Error('Component "'+componentId+'" has not been registered, make sure you register it before calling presentRegistered'));
}var _registeredComponents=

registeredComponents[componentId],component=_registeredComponents.component,resolvers=_registeredComponents.resolvers,rejecters=_registeredComponents.rejecters,
id=getIdAndIncrementCounter();

return createComponentPromise(id,component,props,resolvers,rejecters);
};

var registerComponent=exports.registerComponent=function registerComponent(
id,
component)


{var resolvers=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'resolve';var rejecters=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'reject';
registeredComponents[id]={component:component,resolvers:resolvers,rejecters:rejecters};
};exports.default=

{
present:present,
registerComponent:registerComponent,
presentRegistered:presentRegistered};
//# sourceMappingURL=Manager.js.map